import { createActionGroup } from '@ngrx/store';
import { SetProductBookingContingentReservation } from '@products/models/booking.model';
import { SetContingentReservationDate } from '@products/models/contingent.model';

export const ContingentBookingReservationActions = createActionGroup({
  source: 'Contingent Booking Reservation',
  events: {
    'Set contingent reservation date in booking': (setContingentReservationDates: SetContingentReservationDate[]) => ({
      setContingentReservationDates
    }),
    'Set validated contingent reservation in booking': (
      setProductBookingContingentReservations: SetProductBookingContingentReservation[]
    ) => ({
      setProductBookingContingentReservations
    })
  }
});
